import { LocalityService } from 'src/app/services/location/locality.service';
import { StripeExchangeRateService } from 'src/app/services/payment/stripe/stripe-exchange-rate.service';
import { PriceType } from 'src/app/types/product';
import { AccountService } from 'src/app/services/account/account.service';
import { AccountsListService } from 'src/app/services/accounts/accounts-list.service';
import { Component, OnInit, OnDestroy, NgZone } from '@angular/core';
import { ActivatedRoute, Router, NavigationExtras, Params } from '@angular/router';
import { ModalController, Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { FunctionService } from 'src/app/services/general/function.service';
import { LinkService } from 'src/app/services/general/link.service';
import { CurrencyService } from 'src/app/services/general/currency.service';
import { AccountPackageService } from 'src/app/services/account/account-package.service';
import { ProductAccountService } from 'src/app/services/subscription/product-account.service';
import { ReferralService } from 'src/app/services/subscription/referral.service';
import { VoucherService } from 'src/app/services/subscription/voucher.service';
import { PopupService } from 'src/app/services/general/popup.service';

// import { ProductAccountDetailComponent } from 'src/app/components/subscription/product-account-detail/product-account-detail.component';

import { Product, Price } from 'src/app/interfaces/product';
import { Item } from 'src/app/interfaces/transaction';
import { Voucher } from 'src/app/interfaces/voucher';

import { AccountProductCurrencyList } from 'src/app/commons/currency';
import { AccountProductList, BulkAccountDiscount } from 'src/app/commons/product';
import { UserAccounts } from 'src/app/interfaces/account';
import { Credit } from 'src/app/interfaces/credit';
import { CreditService } from 'src/app/services/subscription/credit.service';
import { LoginService } from 'src/app/services/general/login.service';
import { AuthService } from 'src/app/services/user/auth.service';
import { UserService } from 'src/app/services/user/user.service';
import { AccountsSetupComponent } from 'src/app/components/accounts/accounts-setup/accounts-setup.component';
import { StripeCurrencyList } from 'src/app/commons/stripe';
import { Currency } from 'src/app/interfaces/database';
import { User } from 'src/app/interfaces/user';
import { Locality } from 'src/app/interfaces/general';

@Component({
  selector: 'app-product-account',
  templateUrl: './product-account.page.html',
  styleUrls: ['./product-account.page.scss'],
})
export class ProductAccountPage implements OnInit, OnDestroy {

  ready: boolean;
  iapMode: boolean;
  /**
   * Account product list
   */
  accountProductList = AccountProductList;
  /**
   * Product currency list
   */
  productCurrencyList = [ 'USD', 'SGD' ];
  /**
   * Currency
   */
  currency: string;
  exchangeRate: number;
  /**
   * Item list
   */
  itemList: Item[];
  /**
   * Total
   */
  total: number;
  /**
   * Subtotal
   */
  subtotal: number;
  /**
   * Bulk discount
   */
  bulkDiscount: number;
  /**
   * Bulk discount rate
   */
  bulkDiscountRate: number;
  /**
   * Voucher ID
   */
  voucherId: string;
  /**
   * Referral ID
   */
  referralCode: string;
  /**
   * Voucher
   */
  voucher: Voucher;
  /**
   * Referral rate
   */
  referralRate: number;
  /**
   * Referral discount
   */
  referralDiscount: number;
  /**
   * Voucher discount
   */
  voucherDiscount: number;
  /**
   * Product ID
   */
  productId: string;
  /**
   * Bulk Qty
   */
  bulkQty: any;
  /**
   * Total Qty
   */
  totalQty: number;
  /**
   * Bulk Mode
   */
  bulkMode: boolean;
  /**
   * Gift Mode
   */
  giftMode: boolean;
  /**
   * Upgrade trial to premium flag
   */
  upgradeTrial: boolean;
  /**
   * Upgrade mode for upgrading to full premium package
   */
  upgradeMode: boolean;
  accountId: string;
  /**
   * Disable upgrade
   */
  disableUpgrade: boolean;
  disableCreditPrompt: boolean;
  /**
   * Disable bulk mode
   */
  disableBulkMode: boolean;

  backPremiumPage: boolean;

  productPrice: { [ productId: string]: Price };
  oriPrice: { [ productId: string]: Price };
  upgradePrice: { [ productId: string]: Price };

  private backAddPage: boolean;

  /**
   * Bulk account discount
   */
  private bulkAccountDiscount = BulkAccountDiscount;
  /**
   * Voucher rate
   */
  private voucherRate: number;

  private userSubscription: Subscription;
  private userCreditSubscription: Subscription;
  private accountsListSubscription: Subscription;
  private deviceLocalitySubscription: Subscription;


  /**
   * Constructor
   * @param route route
   * @param router router
   * @param modalController modal controller
   * @param translate translate
   * @param currencyService currency service
   * @param referralService referral service
   * @param voucherService voucher service
   * @param linkService link service
   * @param userService user service
   * @param accountService account service
   * @param functionService function service
   * @param popupService popup service
   */
  constructor(
    private ngZone: NgZone,
    private platform: Platform,
    private route: ActivatedRoute,
    private router: Router,
    private modalController: ModalController,
    private translate: TranslateService,
    private currencyService: CurrencyService,
    private referralService: ReferralService,
    private voucherService: VoucherService,
    private linkService: LinkService,
    private creditService: CreditService,
    private accountService: AccountService,
    private accountPackageService: AccountPackageService,
    private accountsListService: AccountsListService,
    private productAccountService: ProductAccountService,
    private stripeExchangeRateService: StripeExchangeRateService,
    private localityService: LocalityService,
    private authService: AuthService,
    private userService: UserService,
    private loginService: LoginService,
    private functionService: FunctionService,
    private popupService: PopupService,
  ) { }

  /**
   * On init
   */
  ngOnInit() {
    this.watchRoute();
  }

  ngOnDestroy(): void {
    this.unwatch();
  }

  /**
   * Watch route
   */
  watchRoute() {
    this.route.params.subscribe(async (param: Params) => {
      let dismissLoading = true;
      const route = this.router.getCurrentNavigation();
      const state = route?.extras?.state;
      await this.platform.ready();
      await this.popupService.presentLoading();

      if (!this.bulkQty || this.functionService.isEmpty(this.bulkQty)) {
        await this.setupBulkQty();
      }
      if (state?.total) {
        this.total = state?.total;
      } else if (param?.total) {
        this.total = param?.total;
      }

      if (state?.accountId) {
        this.accountId = state?.accountId;
      } else if (param?.accountId) {
        this.accountId = param?.accountId;
      }

      if (state?.currency) {
        this.currency = state?.currency;
      } else if (param?.currency) {
        this.currency = param?.currency;
      }

      if (state?.itemList?.length) {
        this.itemList = state?.itemList;
      } else if (param?.itemList?.length) {
        this.itemList = param.itemList;
      } else {
        this.itemList = [];
      }

      if (state?.productId && state?.productId !== 'null') {
        await this.selectPackage(state.productId);
      } else if (param?.productId) {
        await this.selectPackage(param.productId);
      } else {
        this.productId = '';
      }

      if (state?.giftMode) {
        this.giftMode = state.giftMode;
      } else if (param?.giftMode) {
        this.giftMode = param.giftMode;
      } else {
        this.giftMode = false;
      }

      if (state?.bulkMode) {
        this.bulkMode = state?.bulkMode;
      } else if (param?.bulkMode) {
        this.bulkMode = param.bulkMode;
      } else {
        this.bulkMode = false;
      }

      if (state?.upgradeMode) {
        this.upgradeMode = true;
      } else if (param?.upgradeMode) {
        this.upgradeMode = true;
      } else {
        this.upgradeMode = false;
      }

      if (state?.iapMode) {
        this.iapMode = true;
      } else if (param?.iapMode) {
        this.iapMode = true;
      } else {
        this.iapMode = false;
      }

      if (state?.upgradeTrial) {
        this.upgradeTrial = true;
      } else if (param?.upgradeTrial) {
        this.upgradeTrial = true;
      } else {
        this.upgradeTrial = false;
      }

      if (state?.disableUpgrade) {
        this.disableUpgrade = true;
      } else if (param?.disableUpgrade) {
        this.disableUpgrade = true;
      } else {
        this.disableUpgrade = false;
      }

      if (state?.disableCreditPrompt) {
        this.disableCreditPrompt = true;
      } else if (param?.disableCreditPrompt) {
        this.disableCreditPrompt = true;
      } else {
        this.disableCreditPrompt = false;
      }

      if (state?.backPremiumPage) {
        this.backPremiumPage = true;
      } else if (param?.backPremiumPage) {
        this.backPremiumPage = true;
      } else {
        this.backPremiumPage = false;
      }

      if (state?.backAddPage) {
        this.backAddPage = true;
      } else if (param?.backAddPage) {
        this.backAddPage = true;
      } else {
        this.backAddPage = false;
      }

      if (state?.referralRate) {
        this.referralRate = state.referralRate;
      } else if (param?.referralRate) {
        this.referralRate = param.referralRate;
      }

      if (state?.referralCode && state?.referralCode !== 'null') {
        if (!this.referralRate) {
          await this.validateReferral(state.referralCode, false);
        } else {
          this.referralCode = state?.referralCode;
        }
      } else if (param?.referralCode && param?.referralCode !== 'null') {
        if (!this.referralRate) {
          await this.validateReferral(param.referralCode, false);
        } else {
          this.referralCode = param.referralCode;
        }
      } else {
        this.referralCode = '';
        this.referralRate = 0;
      }

      if (state?.voucher?.voucherId) {
        // this.voucher = state?.voucher;
        await this.validateVoucher(this.voucher?.voucherId, false);
      } else if (param?.voucher?.voucherId) {
        // this.voucher = param.voucher;
        await this.validateVoucher(this.voucher?.voucherId, false);
      } else if (this.voucher?.voucherId) {
        await this.validateVoucher(this.voucher?.voucherId, false);
      } else if (state?.voucherId && state?.voucherId !== 'null') {
        if ((state.voucherId === true || state.voucherId === 'true')) {
          const voucherId = this.voucherService.getCurrentPromo();
          await this.validateVoucher(voucherId, false);
        } else {
          await this.validateVoucher(state.voucherId, false);
        }
      } else if (param?.voucherId && param.voucherId !== 'null') {
        if ((param.voucherId === true || param.voucherId === 'true')) {
          const voucherId = this.voucherService.getCurrentPromo();
          await this.validateVoucher(voucherId, false);
        } else {
          await this.validateVoucher(param.voucherId, false);
        }
      } else {
        this.voucher = null;
        this.voucherId = '';
        const voucherId = this.voucherService.getCurrentPromo();
        await this.validateVoucher(voucherId, false);
      }

      if (this.upgradeMode || ((this.voucherId || this.referralCode) && !this.productId)) {
        this.selectPackage('wedding_account_full');
      }
      if (this.upgradeMode && this.accountPackageService?.accountPackage?.accountPrice?.currency) {
        this.currency = this.accountPackageService.accountPackage.accountPrice.currency;
      } else if (!state?.currency && !param?.currency) {
        dismissLoading = false;
        await this.setupCurrency(true);
      } else {
        await this.setupCurrency();
      }

      // this.toggleBulkMode();
      if (this.itemList?.length) {
        await this.setupSelectedItem();
      }
      
      if (dismissLoading) {
        await this.watchAccountsList();
        this.popupService.dismissLoading();
      }
    });
  }

  ionViewWillEnter() {
    this.watchUser();
    this.watchDeviceLocality();
    this.ready = true;
  }

  /**
   * Before view leave
   */
  ionViewWillLeave() {
    this.unwatch();
    this.ready = false;
  }

  unwatch() {
    this.unwatchAccountsList();
    this.unwatchUserCredit();
    this.unwatchUser();
    this.unwatchDeviceLocality();
  }

  async watchUser() {
    if (!this.userSubscription) {
      this.userSubscription = this.userService.observableUser.subscribe((user: User) => {
        if (user?.locality?.country) {
          this.checkCountryCurrency(user.locality.country);
        }
      });
    }
    
  }

  async unwatchUser() {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
      this.userSubscription = null;
    }
  }

  async watchDeviceLocality() {
    if (!this.deviceLocalitySubscription) {
      this.deviceLocalitySubscription = this.localityService.observableDeviceLocality.subscribe((locality: Locality) => {
        if (locality?.country) {
          this.checkCountryCurrency(locality.country);
        }
      });
    }
    
  }

  async unwatchDeviceLocality() {
    if (this.deviceLocalitySubscription) {
      this.deviceLocalitySubscription.unsubscribe();
      this.deviceLocalitySubscription = null;
    }
  }
  /**
   * Watch Account info
   */
  async watchAccountsList() {
    if (!this.accountsListSubscription) {
      this.accountsListSubscription = this.accountsListService.observableUserAccountsList.subscribe(() => {
        const ownTrialAccountList: UserAccounts[] = this.accountsListService.getOwnTrialAccount();
        if (ownTrialAccountList?.length) {
          const userAccount: UserAccounts = ownTrialAccountList[0];
          this.promptUpgradeTrialAccount(userAccount?.title?.value, userAccount?.accountId);
          if (userAccount?.location?.locality?.country) {
            this.checkCountryCurrency(userAccount.location.locality.country);
          }
        } else {
          const coupleTrialAccountList: UserAccounts[] = this.accountsListService.getCoupleTrialAccount(true);
          if (coupleTrialAccountList?.length) {
            const userAccount: UserAccounts = coupleTrialAccountList[0];
            this.promptUpgradeTrialAccount(userAccount?.title?.value, userAccount?.accountId);
            if (userAccount?.location?.locality?.country) {
              this.checkCountryCurrency(userAccount.location.locality.country);
            }
          } else {
            this.watchUserCredit();
          }
        }
      });
    }
    
  }

  /**
   * Unwatch Account info
   */
  async unwatchAccountsList() {
    if (this.accountsListSubscription) {
      this.accountsListSubscription.unsubscribe();
      this.accountsListSubscription = null;
    }
  }

  async promptIosBack() {
    const modal = await this.popupService.presentConfirm(
      this.translate.instant('PRODUCT.account.msg.ios_back')
    );
    modal.onWillDismiss().then(async (result: any) => {
      if (result?.data?.confirm) {
        if (this.backPremiumPage) {
          this.goAccountPremiumPage();
        } else {
          this.linkService.goMainPage();
        }
      } else {
      }
    });
  }

  async promptUpgradeTrialAccount(title: string, accountId: string) {
    if (!this.disableUpgrade && title && !this.upgradeTrial && !this.upgradeMode) {
      this.disableUpgrade = true;
      const modal = await this.popupService.presentConfirm(
        this.translate.instant('ACCOUNT.msg.upgrade_trial', { title })
      );
      modal.onWillDismiss().then(async (result: any) => {
        if (result?.data?.confirm) {
          this.upgradeTrial = true;
          this.accountId = accountId;
        } else {
          this.upgradeTrial = false;
        }
        this.watchUserCredit();
      });
    } else {
      this.watchUserCredit();
    }
  }

  async watchUserCredit() {
    if (!this.userCreditSubscription) {
      this.userCreditSubscription = this.creditService.observableCreditList.subscribe(() => {
        this.checkAvailableCredit();
      });
    }
  }

  async unwatchUserCredit() {
    if (this.userCreditSubscription) {
      this.userCreditSubscription.unsubscribe();
      this.userCreditSubscription = null;
    }
  }

  async checkCountryCurrency(country: string) {
    const currency = this.currencyService.getCurrencyByCountry(country);
    if (currency?.code && this.currencyService.checkCurrency(currency.code)) {
      this.checkCurrency(currency.code);
    }
  }

  async setupCurrency(watchAccount?: boolean) {
    if (this.authService.loginReady) {
      this.ngZone.run(async () => {
        const deviceCurrency = this.currencyService.getDeviceCurrency().code;
        await this.checkCurrency(deviceCurrency);

        const userCurrency = this.currencyService.getUserCurrency().code;
        if (userCurrency !== deviceCurrency) {
          await this.checkCurrency(userCurrency);
        }

        const currency = this.currencyService.getStripeCurrency()?.code;
        if (deviceCurrency !== currency && userCurrency !== currency) {
          await this.checkCurrency(currency);
        }

        if (!this.currency) {
          this.ngZone.run(() => {
            this.currency = currency;
          });
        }
        await this.setupItemList();
        setTimeout(async () => {
          await this.popupService.dismissLoading();
          if (watchAccount) {
            this.watchAccountsList();
          }
        }, 1000);
      });
    } else {
      setTimeout(() => {
        this.setupCurrency(watchAccount);
      }, 200);
    }
  }

  async checkCurrency(currency?: string) {
    if (!currency && !this.currency) {
      currency = this.currencyService.getStripeCurrency()?.code;
    }
    if (currency) {
      const index = AccountProductCurrencyList.findIndex((x: Currency) => {
        return x.code === currency;
      });
      if (this.productCurrencyList?.indexOf(currency) === -1) {
        this.ngZone.run(() => {
          this.productCurrencyList.unshift(currency);
        });
      }
    }
  }

  checkAvailableCredit() {
    if (!this.disableCreditPrompt) {
      const creditList = this.creditService.getUserAvailableCreditList();
      if (creditList?.length) {
        this.promptUnusedCredit(creditList);
      }
    }
  }

  async promptUnusedCredit(creditList?: Credit[]) {
    this.disableCreditPrompt = true;
    const confirm = await this.popupService.presentConfirm(this.translate.instant('CREDIT.msg.unused_credit_reminder'));
    confirm.onDidDismiss().then((result: any) => {
      if (result?.data?.confirm) {
        let goCreditPage = false;
        if (creditList?.length > 1) {
          let productId = '';
          creditList.forEach((credit: Credit) => {
            if (!productId || productId !== credit.productId) {
              if (productId) {
                goCreditPage = true;
              }
              productId = credit.productId;
            }
          });
        }
        if (goCreditPage) {
          this.goUserCreditPage();
        } else {
          if (this.upgradeTrial && this.accountId) {
            const credit: Credit = this.creditService.getCreditById(creditList[0].creditId);
            this.accountService.upgradeAccountCall(credit, this.accountId, this.upgradeTrial);
          } else {
            this.presentAccountSetupModal(creditList[0]?.creditId);
          }
        }
      }
    });
  }

  /**
   * Validate account product id
   * @param productId product ID
   * @returns true if is valid propduct id
   */
  validateProductId(productId: string, selectProduct?: boolean): boolean {
    const validProductId = this.productAccountService.validateProductId(productId);
    if (selectProduct) {
      this.productId = validProductId;
    }
    return validProductId ? true : false;
  }

  /**
   * Validate referral
   * @param referralCode Referral Code
   * @param loading loading
   */
  async validateReferral(referralCode: string, loading?: boolean) {
    if (referralCode) {
      if (loading) {
        await this.popupService.presentLoading();
      }
      if (!this.referralRate) {
        this.referralRate = await this.referralService.validateReferralCode(referralCode);
      }
      if (this.referralRate) {
        this.referralCode = referralCode;
      }
      await this.setupItemList();
      if (loading) {
        this.popupService.dismissLoading();
      }
    }
  }

  /**
   * present referral modal
   * @param referralCode referral id
   */
  async presentReferralModal(referralCode?: any) {
    const modal = await this.popupService.presentInput(
      this.translate.instant('MENU.referral'),
      '',
      this.translate.instant('REFERRAL.lbl.placeholder'),
      './assets/wedding/icon/payment/voucher.svg',
      referralCode,
      true,
      'text',
      'referral',
      this.translate.instant('BTN.apply')
    );
    modal.onDidDismiss().then((result) => {
      if (!result?.data?.cancel && result?.data?.input) {
        this.validateReferral(result?.data?.input, true);
      }
    });
  }

  /**
   * Validate voucher
   * @param voucherId voucher id
   * @param loading loading
   */
  async validateVoucher(voucherId: string, loading?: boolean) {
    if (loading) {
      await this.popupService.presentLoading(this.translate.instant('VOUCHER.validation.voucher'));
    }
    if (voucherId && voucherId !== this.voucher?.voucherId && voucherId !== this.voucherId) {
      this.voucher = await this.voucherService.validateVoucher(voucherId, 'account', this.itemList, this.bulkMode, this.accountId);
      if (this.voucher?.voucherId && this.voucher?.percent) {
        this.voucherRate = this.voucher.percent;
        this.voucherId = voucherId;
        if (this.voucher?.maxQty === 1) {
          this.bulkMode = false;
          await this.setupBulkQty();
        } else if (this.voucher?.minQty > 1) {
          this.bulkMode = true;
          await this.setupBulkQty();
        }
        if (this.voucher?.productId) {
          this.productId = this.voucher.productId;
        }
        if (this.voucher?.disableReferral && (this.referralCode || this.referralRate)) {
          this.referralCode = '';
          this.referralRate = 0;
        }
      } else {
        this.voucher = null;
        this.voucherId = '';
      }
    }
    if (this.voucher?.voucherId && !this.voucherId) {
      this.voucherId = this.voucher.voucherId;
    }
    if (this.voucher?.percent && this.voucher?.percent !== this.voucherRate) {
      this.voucherRate = this.voucher.percent;
    }
    await this.setupItemList();
    if (loading) {
      await this.popupService.dismissLoading();
    }
  }

  checkVoucherQty(qty: number) {
    if (this.voucher?.voucherId) {
      if (qty) {
        if (this.voucher?.maxQty && qty > this.voucher.maxQty) {
          this.popupService.presentAlert(this.translate.instant('VOUCHER.validation.max_qty', { max: this.voucher.maxQty }));
          return false;
        } else if (this.voucher?.qty && qty > this.voucher.qty) {
          this.popupService.presentAlert(this.translate.instant('VOUCHER.validation.max_qty', { max: this.voucher.qty }));
          return false;
        }
      }
      if (this.voucher?.minQty && this.voucher?.minQty > qty) {
        this.popupService.presentAlert(this.translate.instant('VOUCHER.validation.min_qty', { min: this.voucher.minQty }));
        return false;
      }
    }
    return true;
  }

  /**
   * present voucher input modal
   * @param voucher voucher id
   */
  async presentVoucherInputModal(voucher?: string) {
    const modal = await this.popupService.presentInput(
      this.translate.instant('VOUCHER.lbl.voucher'), '', this.translate.instant('VOUCHER.lbl.placeholder'), './assets/wedding/icon/payment/voucher.svg', voucher, true, 'text', 'voucher', this.translate.instant('BTN.apply'));
    modal.onDidDismiss().then((result) => {
      if (!result?.data?.cancel && result?.data?.input) {
        this.validateVoucher(result?.data?.input, true);
      }
    });
  }

  /**
   * Present product account detail modal
   * @param productId product id
   */
  // async presentProductAccountDetailModal(productId?: string) {
  //   const modal = await this.modalController.create({
  //     component: ProductAccountDetailComponent,
  //     componentProps: {
  //       purchaseMode: true,
  //       upgradeMode: this.upgradeMode,
  //       productId: productId ? productId : this.productId,
  //     }
  //   });
  //   modal.present();
  //   modal.onWillDismiss().then((result) => {
  //     if (result?.data?.productId) {
  //       this.selectPackage(result.data.productId);
  //     }
  //   });
  // }

  async prompVoucher(checkout?: boolean) {
    if (!this.voucher?.voucherId) {
      const voucher = this.voucherService.getCurrentPromo();
      const confirm = await this.popupService.presentConfirm(
        this.translate.instant('VOUCHER.reminder', { voucher })
      );
      confirm.onWillDismiss().then((result) => {
        if (result?.data?.confirm) {
          this.validateVoucher(voucher, true);
        } else if (checkout) {
          this.goPaymentPage();
        }
      });
    } else {
      this.goPaymentPage();
    }
  }

  /**
   * Toggle bulk mode
   */
  async toggleBulkMode() {
    if (this.bulkMode) {
      await this.setupBulkQty();
    }
    await this.setupItemList();
  }

  async setupSelectedItem() {
    if (this.bulkMode) {
      await this.setupBulkQty();
    } else {
      this.itemList?.forEach((item: Item) => {
        if (item?.qty && item.productId) {
          this.productId = item.productId;
        }
      });
    }
  }

  /**
   * Setup bulk qty
   */
  async setupBulkQty() {
    this.bulkQty = {};
    this.accountProductList?.forEach((product: Product) => {
      if (product?.productId) {
        const index = this.itemList?.findIndex((item: Item) => {
          return item?.productId && item?.qty && item?.productId === product?.productId;
        });
        if (index !== -1 && this.itemList?.[index]?.qty) {
          this.bulkQty[product.productId] = this.itemList[index].qty;
        } else {
          this.bulkQty[product.productId] = 0;
        }
      }
    });
  }

  /**
   * Select package
   * @param productId product ID
   */
  async selectPackage(productId: string) {
    if (!this.bulkMode) {
      if (this.voucher?.productId && this.voucher.productId !== productId) {
        this.popupService.presentAlert(this.translate.instant('VOUCHER.validation.invalid_product_id'));
      } else if (this.validateProductId(productId, true)) {
        await this.setupItemList();
      } else {
        if (productId === 'wedding_account_app' && !this.platform.is('hybrid')) {
          this.popupService.presentAlert(this.translate.instant('PRODUCT.account.msg.app_required'));
        } else if (productId === 'wedding_account_web' && this.platform.is('hybrid')) {
          this.popupService.presentAlert(this.translate.instant('PRODUCT.account.msg.web_required'));
        } else {
          this.validateProductId('wedding_account_full');
          await this.setupItemList();
        }
      }
    }
  }

  /**
   * Add Qty
   * @param productId product ID
   */
  addQty(productId: string) {
    if (productId) {
      if (!this.bulkQty?.[productId]) { this.bulkQty[productId] = 0; }
      if (this.checkVoucherQty(this.totalQty + 1)) {
        this.bulkQty[productId]++;
        this.setupItemList();
      }
    }
  }

  /**
   * Minus Qty
   * @param productId product ID
   */
  minusQty(productId: string) {
    if (productId) {
      if (!this.bulkQty?.[productId]) { this.bulkQty[productId] = 0; }
      if (this.bulkQty[productId] && this.checkVoucherQty(this.totalQty - 1)) {
        this.bulkQty[productId]--;
        this.setupItemList();
      }
    }
  }

  async setupItem(product: Product, priceType: PriceType): Promise<Item | null> {
    if (product) {
      let convertCurrency = '';
      let currencyIndex = product.priceList?.findIndex((price: Price) => price?.currency === this.currency);
      if (currencyIndex === -1) {
        if (StripeCurrencyList.indexOf(this.currency) !== -1) {
          convertCurrency = 'USD';
          currencyIndex = product.priceList?.findIndex((price: Price) => price?.currency === convertCurrency);
        }
      }
      if (currencyIndex !== -1) {
        const price: Price = {
          currency: this.currency,
          amount: 0
        };
        const item: Item = {
          productId: product.productId,
          productType: product.productType,
          productName: product.productName,
          qty: 1,
          oriPrice: price,
          price,
          payment: price,
        };
        if (priceType === 'upgrade') {
          item.oriPrice = { ...product.upgradePriceList[currencyIndex] };
          item.price = { ...product.upgradePriceList[currencyIndex] };
          item.payment = { ...product.upgradePriceList[currencyIndex] };
        } else {
          item.oriPrice = { ...product.oriPriceList[currencyIndex] };
          item.price = { ...product.priceList[currencyIndex] };
          item.payment = { ...product.priceList[currencyIndex] };
        }

        if (convertCurrency) {
          this.exchangeRate = this.stripeExchangeRateService.getExchangeRateByCurrency(this.currency);
          if (this.exchangeRate > 0) {
            item.oriPrice.amount = this.currencyService.rounding(this.currency, item.oriPrice.amount * this.exchangeRate);
            item.price.amount = this.currencyService.rounding(this.currency, item.price.amount * this.exchangeRate);
            item.payment.amount = this.currencyService.rounding(this.currency, item.payment.amount * this.exchangeRate);
            item.oriPrice.currency = this.currency;
            item.price.currency = this.currency;
            item.payment.currency = this.currency;
          } else {
            this.ngZone.run(() => {
              this.currency = convertCurrency;
            });
          }
        }
        if (this.bulkMode && this.bulkQty) {
          item.qty = this.bulkQty[product.productId];
        }
        return item;
      }
    }
    return null;
  }

  /**
   * Setup Item list
   */
  async setupItemList() {
    // await this.ngZone.run(async () => {
      this.itemList = [];
      if (this.upgradeMode) {
        const productIndex = this.accountProductList?.findIndex((product: Product) => product?.productId === this.productId);
        if (productIndex !== -1) {
          const product: Product = this.functionService.cloneDeep(this.accountProductList[productIndex]);
          const item = await this.setupItem(product, 'upgrade');
          if (item) {
            this.itemList.push(item);
          }
        }
      } else if (this.bulkMode) {
        if (!this.bulkQty || this.functionService.isEmpty(this.bulkQty)) {
          await this.setupBulkQty();
        }
        if (this.bulkQty && !this.functionService.isEmpty(this.bulkQty)) {
          for (const key of Object.keys(this.bulkQty)) {
            if (this.voucher?.productId) {
              if (this.voucher.productId === key) {
                if (this.voucher?.minQty && this.voucher.minQty > this.bulkQty[key]) {
                  this.bulkQty[key] = this.voucher.minQty;
                } else if (this.voucher?.maxQty && this.bulkQty[key] > this.voucher.maxQty) {
                  this.bulkQty[key] = this.voucher.maxQty;
                }
                if (!this.bulkQty[key]) {
                  this.bulkQty[key] = 1;
                }
              }
              if (this.voucher.productId !== key && this.bulkQty[key]) {
                this.bulkQty[key] = 0;
              }
            }
            if (key && this.bulkQty[key]) {
              const productIndex = this.accountProductList?.findIndex((product: Product) => product?.productId === key);
              if (productIndex !== -1) {
                const product: Product = this.functionService.cloneDeep(this.accountProductList[productIndex]);
                const item = await this.setupItem(product, 'selling');
                if (item && this.itemList.findIndex((x: Item) => x.productId === item.productId) === -1) {
                  this.itemList.push(item);
                }
              }
            }
          }
        }
      } else if (this.productId) {
        const productIndex = this.accountProductList?.findIndex((product: Product) => product?.productId === this.productId);
        if (productIndex !== -1) {
          const product: Product = this.functionService.cloneDeep(this.accountProductList[productIndex]);
          const item = await this.setupItem(product, 'selling');
          if (item) {
            this.itemList.push(item);
          }
        }
      }

      if (!this.productPrice) {
        this.productPrice = {};
      }
      if (!this.oriPrice) {
        this.oriPrice = {};
      }
      if (!this.upgradePrice) {
        this.upgradePrice = {};
      }
      this.accountProductList?.forEach((x: Product) => {
        if (x?.productId && x?.priceList && x?.oriPriceList && x?.upgradePriceList) {
          this.productPrice[x.productId] = this.getProductPrice(x.priceList);
          this.oriPrice[x.productId] = this.getProductPrice(x.oriPriceList);
          this.upgradePrice[x.productId] = this.getProductPrice(x.upgradePriceList);
        }
      });
      await this.setupSubtotal();
    // });
  }

  /**
   * Setup subtotal
   */
  async setupSubtotal() {
    let subtotal = 0;
    let totalQty = 0;
    this.itemList?.forEach((item: Item) => {
      if (item.qty > 0) {
        totalQty += item.qty;
        if (item.payment.currency === this.currency) {
          subtotal += item.payment.amount * item.qty;
        }
      }
    });
    this.subtotal = subtotal;
    this.totalQty = totalQty;
    await this.setupTotal();
  }

  /**
   * Setup total
   */
  async setupTotal() {
    this.bulkDiscountRate = 0;
    this.bulkDiscount = 0;
    this.voucherDiscount = 0;
    this.referralDiscount = 0;

    if (this.bulkMode) {
      Object.keys(this.bulkAccountDiscount)?.forEach((key: string) => {
        if (this.totalQty >= Number(key)) {
          this.bulkDiscountRate = this.bulkAccountDiscount[key];
          return true;
        }
      });
    }

    this.total = 0;
    this.itemList?.forEach((item: Item) => {
      if (item?.price?.currency !== this.currency) {
        this.ngZone.run(() => {
          this.currency = item.price.currency;
        });
      }
      if (item?.qty && item?.price?.currency && item?.price?.amount && item?.price?.currency === this.currency) {
        if (this.bulkDiscountRate) {
          const bulkDiscount = this.currencyService.rounding(this.currency, item.payment.amount * this.bulkDiscountRate);
          item.payment.amount -= bulkDiscount;
          this.bulkDiscount += (bulkDiscount * item.qty);
        }
        if (this.voucherId && this.voucher?.voucherId && this.voucherRate) {
          const voucherDiscount = this.currencyService.rounding(this.currency, item.payment.amount * this.voucherRate);
          item.payment.amount -= voucherDiscount;
          this.voucherDiscount += (voucherDiscount * item.qty);
        }
        if (this.referralCode && this.referralRate) {
          const referralDiscount = this.currencyService.rounding(this.currency, item.payment.amount * this.referralRate);
          item.payment.amount -= referralDiscount;
          this.referralDiscount += (referralDiscount * item.qty);
        }
        this.total += (item.payment.amount * item.qty);
      }
    });
    this.total = this.currencyService.rounding(this.currency, this.total);
  }

  /**
   * Get price from product price list  based on current currency
   * @param productPriceList product price list
   * @returns price
   */
  getProductPrice(productPriceList: Price[]): Price {
    if (productPriceList?.length) {
      const currencyIndex = productPriceList?.findIndex((x: Price) => x?.currency === this.currency);
      if (currencyIndex !== -1) {
        return productPriceList[currencyIndex];
      } else if (StripeCurrencyList?.indexOf(this.currency) !== -1) {
        const usdIndex = productPriceList?.findIndex((x: Price) => x?.currency === 'USD');
        if (usdIndex !== -1) {
          const price = { ...productPriceList[usdIndex] };
          this.exchangeRate = this.stripeExchangeRateService.getExchangeRateByCurrency(this.currency);
          if (this.exchangeRate > 0) {
            price.amount = this.currencyService.rounding(this.currency, price.amount * this.exchangeRate);
            price.currency = this.currency;
          } else {
            price.currency = 'USD';
          }
          return price;
        }
      }
    }
    return null;
  }

  /**
   * Check user login
   */
  async checkUserLogin() {
    await this.popupService.presentLoading();
    if (this.authService.currentUser) {
      if (this.userService.user?.name) {
        this.checkAnonymousLogin();
      } else {
        await this.popupService.dismissLoading();
        const modal = await this.loginService.presentUserSetupModal();
        modal.onDidDismiss().then(() => {
          this.checkAnonymousLogin();
          this.loginService.userSetupModal = null;
        });
      }
    } else {
      this.presentLoginModal(false, false);
    }
  }

  /**
   * Check anonymous login
   */
  async checkAnonymousLogin() {
    if (this.userService?.user?.isAnonymous) {
      this.presentLoginModal(false, false, true);
    } else {
      this.payment();
    }
  }

  /**
   * Present login modal
   * @param loginRequired login required
   * @param showAnonymousLogin show anonymous login
   * @param linkProvider link provider
   */
  async presentLoginModal(loginRequired?: boolean, showAnonymousLogin?: boolean, linkProvider?: boolean) {
    await this.popupService.dismissLoading();
    const modal = await this.loginService.presentLoginModal(loginRequired, showAnonymousLogin, linkProvider);
    modal.onDidDismiss().then(async () => {
      if (this.userService.user && (showAnonymousLogin || !this.userService?.user?.isAnonymous)) {
        await this.popupService.presentLoading();
        this.payment();
      }
    });
  }

  /**
   * Payment
   */
  payment() {
    if (this.authService.currentUser) {
      if (this.currency && this.itemList?.length) {
        if (!this.voucher?.voucherId) {
          this.prompVoucher(true);
        } else {
          this.goPaymentPage();
        }
        // if (this.total) {
        //   this.prompVoucher(true);
        // } else {
        //   this.getFree();
        // }
      } else {
        this.popupService.presentAlert(this.translate.instant('PRODUCT.account.msg.product_required'));
      }
    }
  }

  /**
   * Get free payment
   */
  // async getFree() {
  //   if (this.onlineService.isOnline()) {
  //     await this.paymentService.createFreePaymentCall(
  //       {
  //         currency: this.currency,
  //         amount: 0
  //       },
  //       this.paymentService.getCustomerData(),
  //       this.itemList,
  //       this.giftMode,
  //       this.bulkMode,
  //       this.referralCode,
  //       this.voucher,
  //       this.upgradeMode,
  //       this.upgradeTrial
  //     );
  //   }
  // }

  /**
   * Present account setup modal
   */
  async presentAccountSetupModal(creditId: string) {
    if (creditId) {
      const modal = await this.modalController.create({
        component: AccountsSetupComponent,
        componentProps: {
          premium: true,
          creditId
        }
      });
      modal.present();
    } else {
      this.popupService.presentActionError();
    }
  }

  /**
   * Back
   */
  back() {
    if (this.platform.is('ios') && this.platform.is('hybrid')) {
      this.promptIosBack();
    } else {
      if (this.backPremiumPage) {
        this.goAccountPremiumPage();
      } else {
        this.linkService.goMainPage();
      }
    }
  }

  generateParam(): NavigationExtras {
    const navigationExtras: NavigationExtras = {
      state: {
        transactionType: 'account',
        total: this.total,
        accountId: this.accountId,
        currency: this.currency,
        itemList: this.itemList,
        referralCode: this.referralCode,
        referralRate: this.referralRate,
        voucher: this.voucher,
        voucherId: this.voucherId,
        giftMode: this.giftMode,
        bulkMode: this.bulkMode && this.totalQty > 1 ? true : false,
        upgradeTrial: this.upgradeTrial,
        upgradeMode: this.upgradeMode,
        iapMode: this.iapMode,
        disableUpgrade: this.disableUpgrade,
        disableCreditPrompt: this.disableCreditPrompt,
        backPremiumPage: this.backPremiumPage,
        backAddPage: this.backAddPage,
      }
    };
    return navigationExtras;
  }

  /**
   * Go payment page
   */
  goPaymentPage() {
    this.popupService.dismissLoading();
    if (this.currency && this.itemList?.length) {
      this.router.navigate(['/payment/stripe-checkout'], this.generateParam());
    } else {
      // prompt error
      this.popupService.presentActionError();
    }
  }

  goAccountComparisonPage() {
    this.router.navigate(['/subscription/account-comparison'], this.generateParam());
  }

  goAccountPremiumPage() {
    this.router.navigate([ '/subscription/premium' ], this.generateParam());
  }

  goUserCreditPage() {
    this.router.navigate(['user/credit']);
  }
}
